<!-- Default Client Sidebar (When NOT on Power BI Dashboard) -->
<div class="modern-sidebar" *ngIf="!isPowerBiRoute">
    <!-- Brand Logo -->
    <div class="brand-section">
        <div class="brand-logo">
            <pf-image
                src="assets/img/logo-no-text-no-bg.png"
                alt="SmartPoultry Logo"
                class="logo-icon"
                height="64"
                width="64"
                rounded="true"
            ></pf-image>
            <h2 class="brand-title">SMART POULTRY</h2>
        </div>

        <!-- Mobile close button -->
        <button class="mobile-close-btn" (click)="closeSidebar()">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <div class="form-inline">
        <!-- <app-sidebar-search></app-sidebar-search> -->
    </div>

    <!-- Sidebar Menu -->
    <nav class="sidebar-nav">
        <ul class="nav-menu">
            <app-menu-item *ngFor="let item of menu" [menuItem]="item" />
        </ul>
    </nav>
</div>

<!-- Power BI Sidebar Panel (When on /power-bi route) -->
<div class="powerbi-sidebar-panel" *ngIf="isPowerBiRoute">
    <!-- Brand Card (Click acts as Back to Main Site) -->
    <a class="brand-card" (click)="backToMainSite()" title="Back to Main Site" data-tooltip="Main Site">
        <img src="assets/img/logo-no-bg.png" alt="Smart Poultry" class="brand-img" />
        <div class="brand-text">
            <strong class="brand-title">Smart Poultry</strong>
            <span class="brand-subtitle">INTELLIGENCE PLATFORM</span>
        </div>
    </a>

    <!-- Menu Navigation -->
    <nav class="pbi-menu-list">
        <button class="back-main-btn" (click)="backToMainSite()" title="Back to Main Site" data-tooltip="Back to Main Site">
            <i class="nav-icon fas fa-arrow-left"></i>
            <span class="btn-text">Back to Main Site</span>
        </button>
        <button [class.active]="activeDashboard === 'Operational'" (click)="selectDashboard('Operational')" title="Operational Dashboard" data-tooltip="Operational Dashboard">
            <i class="nav-icon fas fa-chart-line"></i>
            <span class="btn-text">Operational Dashboard</span>
        </button>
        <div class="pbi-submenu">
            <button [class.active]="activeDashboard === 'Financial'" (click)="selectDashboard('Financial')" title="Financial Dashboard" data-tooltip="Financial Dashboard">
                <i class="nav-icon fas fa-coins"></i>
                <span class="btn-text">Financial Dashboard</span>
            </button>
            <button [class.active]="activeDashboard === 'Executive'" (click)="selectDashboard('Executive')" title="Executive Dashboard" data-tooltip="Executive Dashboard">
                <i class="nav-icon fas fa-user-tie"></i>
                <span class="btn-text">Executive Dashboard</span>
            </button>
        </div>
    </nav>

    <!-- Quick Actions -->
    <section class="pbi-quick-actions">
        <h3 class="section-title">Quick Actions</h3>
        <button (click)="triggerExport()" title="Export Report" data-tooltip="Export Report">
            <i class="nav-icon fas fa-file-export"></i>
            <span class="btn-text">Export Report</span>
        </button>
        <button (click)="triggerRefreshSchedule()" title="Refresh Schedule" data-tooltip="Refresh Schedule">
            <i class="nav-icon fas fa-sync-alt"></i>
            <span class="btn-text">Refresh Schedule</span>
        </button>
        <button (click)="triggerDownloadData()" title="Data Download" data-tooltip="Data Download">
            <i class="nav-icon fas fa-file-excel"></i>
            <span class="btn-text">Data Download</span>
        </button>

        <!-- Admin Only: Power BI Dataset Config Settings -->
        <button *ngIf="isAdminUser" (click)="triggerPowerBiSettings()" title="Power BI Settings" data-tooltip="Power BI Settings" class="admin-settings-btn">
            <i class="nav-icon fas fa-sliders-h"></i>
            <span class="btn-text">Power BI Settings</span>
        </button>
    </section>

    <!-- Data Scope -->
    <section class="pbi-data-scope">
        <h3 class="section-title">Data Scope</h3>
        <p class="scope-text">Tenant: {{ tenantDomain || 'Loading...' }}</p>
    </section>
</div>
